import React from 'react'
import './about.css'
import { aboutPara } from '../../utils/introductionData'
import { socialMedia } from '../../utils/socialMediaData'

const About = () => {
  return (
    <div id='about' className='bg-info-subtle p-3'>
      <div className="container text-center">
        <div className="row">
          <div className="col-12 col-md-6">
            <img className='aboutSectionPhoto' src='aayushAbout.png' alt='...'/>
            <div className="circle"></div>
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center">
            <div className='aboutWrapper p-5'>
              <div className='aboutTop'>
                <h1 className='fs-1 fw-bolder text-body-tertiary'>Who is <span className='fst-italic fw-medium text-primary'>Aayush Srivastava?</span></h1>
              </div>
              <div className='aboutMid p-1 text-start'>
                <p className='fs-5 text-secondary'>{aboutPara}</p>
              </div>
              <div className='aboutBottom'>
                <ul className='nav justify-content-center'>
                  {
                    socialMedia.map(media =>
                      <li className='nav-item m-2'>
                        <a href={media.url} target='_blank' rel="noopener noreferrer">
                          <img src={media.image} alt='...' />
                        </a>
                      </li>
                    )
                  }
                </ul>
              </div>
              <div className='mt-4'>
                <a href='#contact'>
                  <button className='btn about-btn rounded-pill text-light fw-medium fs-5' style={{ width: '150px' }}>Let's Talk &rarr;</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About